import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class NoTranslationInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      mergeMap((event: HttpEvent<any>) => {
        const isJsonApiResponse =
          event instanceof HttpResponse && request.method === 'GET' && request.url.includes('/jsonapi/');

        if (isJsonApiResponse && event.body && event.body.data === null) {
          return throwError(
            () =>
              new HttpErrorResponse({
                status: 406,
                statusText: 'Not Acceptable',
                url: request.url,
                error: {
                  message: 'No translation available for the requested language.',
                },
              })
          );
        }

        return of(event);
      })
    );
  }
}
